
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {AuthService} from "../../services/auth.service";
import { HttpClient } from '@angular/common/http';
import {FeatureMap} from '@webmate-web-core/shared/types/feature';

@Injectable({
  providedIn: "root"
})
export class FeatureApi {

  constructor (public OAuth2AuthService: AuthService, private http: HttpClient) { }

  getFeaturesForUser(): Observable<FeatureMap> {
    return this.http.get<any>("/users/features");
  }

}
